/**
 * CourseyVoyage i18n 執行期常數與工具函式
 */
import type { Locale } from './types';

export const SUPPORTED_LOCALES: { code: Locale; label: string }[] = [
    { code: 'zh-TW', label: '繁體中文' },
    { code: 'en', label: 'English' },
    { code: 'ja', label: '日本語' },
];

export const DEFAULT_LOCALE: Locale = 'zh-TW';

/** 星期 key（0=Sun, 1=Mon, ... 6=Sat） */
export const WEEKDAY_KEYS = ['weekday.sun', 'weekday.mon', 'weekday.tue', 'weekday.wed', 'weekday.thu', 'weekday.fri', 'weekday.sat'] as const;

/** 週視圖星期順序（週一～週日） */
export const WEEKDAY_KEYS_WEEK_VIEW = ['weekday.mon', 'weekday.tue', 'weekday.wed', 'weekday.thu', 'weekday.fri', 'weekday.sat', 'weekday.sun'] as const;

/** 簡單佔位符替換：{key} -> value */
export function interpolate(template: string, params: Record<string, string | number>): string {
    return Object.entries(params).reduce(
        (acc, [key, value]) => acc.replace(new RegExp(`\\{${key}\\}`, 'g'), String(value)),
        template
    );
}
